import I18n from 'i18n-js';
import React from 'react';
import { IUserContext, withUserContext } from '@reverbdotcom/commons/src/components/user_context_provider';
import bind from '@reverbdotcom/commons/src/bind';
import heartFilledIcon from '@reverbdotcom/cadence/icons/core/heart-filled.svg?component';
import heartEmptyIcon from '@reverbdotcom/cadence/icons/core/heart-empty.svg?component';
import { RCIcon } from '@reverbdotcom/cadence/components/RCIcon/RCIcon';
import classNames from 'classnames';

interface Props extends IUserContext {
  openModal: () => void;
  disabled: boolean;
  isFavorited: boolean;
  entityType: string;
  disabledTooltipText?: string;
  renderWithBanner: boolean;
}

export class FavoriteButton extends React.Component<Props, null> {
  @bind
  handleClick(e) {
    e.preventDefault();

    if (this.props.disabled) {
      return;
    }

    this.props.openModal();
  }

  favoriteType() {
    return I18n.t(`discovery.favorites.favoriteButton.entityTypes.${this.props.entityType}`);
  }

  linkText() {
    if (this.props.isFavorited) {
      return I18n.t('discovery.favorites.favoriteButton.hasFavorited', { type: this.favoriteType() });
    }

    return I18n.t('discovery.favorites.favoriteButton.addFavorite', { type: this.favoriteType() });
  }

  tooltipText() {
    if (!this.props.disabled) { return null; }

    return this.props.disabledTooltipText ||
      I18n.t('discovery.favorites.favoriteButton.tooltipText');
  }

  buttonClass() {
    if (this.props.entityType === 'product') { return 'primary'; }
    if (this.props.renderWithBanner) { return 'primary'; }
    return 'link';
  }

  render() {
    const { disabled, isFavorited, entityType } = this.props;
    if (!entityType) { return null; }

    const classes = classNames(
      'favorite-button__button',
      {
        'favorite-button__button-link': this.buttonClass() === 'link',
        'favorite-button__button-primary': this.buttonClass() === 'primary',
        'favorite-button__button-favorited': this.buttonClass() !== 'link' && isFavorited,
      },
    );

    return (
      <>
        <button
          className={classes}
          onClick={this.handleClick}
          type="button"
          data-disabled={disabled || null}
        >
          <RCIcon svgComponent={isFavorited ? heartFilledIcon : heartEmptyIcon} inline />
          {this.linkText()}
        </button>
      </>
    );
  }
}

export default withUserContext(FavoriteButton);
